'use strict';

import * as d3 from 'd3';

const defaultBoundaries = {
  width: 180,
  height: 180,
  donutWidth: 14
};

class PieGraph {
  constructor(graphElement, dataset, boundaries = defaultBoundaries) {
    this.graph = {
      width: boundaries.width,
      height: boundaries.height,
      donutWidth: boundaries.donutWidth,
      radius: (boundaries.width - 40) / 2,
      dataset,
      graphElement
    };
  }

  updateDataset(dataset) {
    this.graph.dataset = [...dataset];
    this.remove();
    this.render();
  }

  remove() {
    d3.select(this.graph.graphElement)
      .selectAll('svg')
      .remove();
  }

  render() {
    const dx = this.graph.width / 2;
    const dy = this.graph.height / 2;

    const svg = d3
      .select(this.graph.graphElement)
      .append('svg')
      .attr('width', this.graph.width)
      .attr('height', this.graph.height)
      .append('g')
      .attr('transform', `translate(${dx}, ${dy})`);

    svg.append('g').attr('class', 'labels');
    svg.append('g').attr('class', 'lines');

    const arc = d3
      .arc()
      .innerRadius(0)
      .outerRadius(this.graph.radius);

    const pie = d3
      .pie()
      .value(data => data.value)
      .sort(null);

    const sum = (sum, item) => sum + item.value;
    const hasSomeValue = this.graph.dataset.reduce(sum, 0);

    if (!hasSomeValue) {
      svg
        .selectAll('path')
        .data(pie([{ value: 1 }]))
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('fill', () => '#0001');
      return;
    }

    svg
      .selectAll('path')
      .data(pie(this.graph.dataset))
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', dataPiece => {
        return dataPiece.data.color;
      })
      .on('mouseover', function(event) {
        d3.select(this).attr('transform', 'scale(1.1)');
        const legend = document.querySelector(`#qs-legend-${event.index}`);
        legend.classList.add('active');
      })
      .on('mouseleave', function(event) {
        d3.select(this).attr('transform', 'scale(1)');
        const legend = document.querySelector(`#qs-legend-${event.index}`);
        legend.classList.remove('active');
      })
      .attr('transform', 'translate(0, 0)');
  }
}

export default PieGraph;
